module.exports = __webpack_public_path__ + "static/media/POL.3785a84d.svg";